import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPhone, vendorSendOTP } from "../../redux/slices/vendorAuthSlice";

const VendorPortal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { phone, loading, isOTPSent, error } = useSelector(
    (state) => state.vendorAuth
  );

  const [inputPhone, setInputPhone] = useState("");
  const [checked, setChecked] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  // useEffect(() => {
  //   if (isOTPSent) {
  //     setSnackbar({
  //       open: true,
  //       message: "OTP sent successfully!",
  //       severity: "success",
  //     });
  //     navigate("/vendorportal/otp");
  //   }
  // }, [isOTPSent, navigate]);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const onhandleSubmit = async () => {
    if (!/^\d{10}$/.test(inputPhone.trim())) {
      setSnackbar({
        open: true,
        message: "Phone number must be exactly 10 digits.",
        severity: "error",
      });
      return;
    }

    if (!checked) {
      setSnackbar({
        open: true,
        message: "Please agree with the Terms & Privacy Policy.",
        severity: "error",
      });
      return;
    }

    const phoneNumber = `+91${inputPhone}`;

    try {
      const resultAction = await dispatch(vendorSendOTP(phoneNumber));
      if (vendorSendOTP.fulfilled.match(resultAction)) {
        setSnackbar({
          open: true,
          message: "OTP sent successfully!",
          severity: "success",
        });
        setTimeout(() => {
          // localStorage.setItem("phone", phoneNumber);
          navigate("/vendorportal/otp");
        }, 1000); // 1-second delay
        dispatch(setPhone(phoneNumber));
        // State like `isOTPSent` will trigger the useEffect and navigate.
      } else {
        setSnackbar({
          open: true,
          message: "Failed to send OTP, Please check your phone number!",
          severity: "error",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Something went wrong. Please try again later.",
        severity: "error",
      });
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="w-1/2 overflow-hidden hidden md:block">
        <img
          src="/assests/vendorPortalImages/vendorLogin.png"
          alt="Background"
          className="h-screen p-4 rounded-[65px] w-full object-cover"
        />
      </div>
      <div className="mx-auto flex justify-start items-center">
        <div className="lg:w-[30rem] ">
          <div className="flex justify-start">
            <img
              src="/assests/images/pixell dark.png"
              alt="Pixell Logo"
              className="h-24 w-[239px]"
            />
          </div>
          <h2 className="mt-6 text-start text-2xl">
            Welcome to <span className="font-bold italic">Pixell</span>
          </h2>
          <p className="mt-2 mb-16 text-start text-base">
            Sign in to start working with us
          </p>
          <div className="mb-6">
            <label
              htmlFor="phone"
              className="block mb-2 text-base font-medium text-gray-700"
            >
              Phone Number <span className="text-black">*</span>
            </label>
            <div className="flex items-center border rounded w-full focus-within:ring-1 focus-within:ring-blue-600">
              <span className="px-3 text-gray-700 whitespace-nowrap">+91</span>
              <input
                type="tel"
                maxLength={10}
                value={inputPhone}
                onChange={(e) =>
                  setInputPhone(e.target.value.replace(/\D/g, ""))
                }
                className="w-full px-3 py-2 outline-none"
                placeholder="Enter 10-digit phone number"
              />
            </div>
            {/* {localError && (
              <p className="text-red-500 text-sm mt-1">{error || localError}</p>
            )} */}
          </div>

          <FormControlLabel
            control={
              <Checkbox
                checked={checked}
                onChange={() => setChecked(!checked)}
              />
            }
            label={
              <span className=" text-sm text-gray-500">
                I accept the{" "}
                <Link href="/term&condition" rel="noopener" underline="hover">
                  Terms
                </Link>{" "}
                and{" "}
                <Link href="/privacy" rel="noopener" underline="hover">
                  Privacy Policy.
                </Link>
              </span>
            }
          />
          <div className="relative mt-4">
            <button
              type="submit"
              className="w-full py-2 rounded font-semibold"
              style={{
                backgroundColor: "var(--primary-color)",
                color: "var(--secondary-color)",
              }}
              disabled={loading}
              onClick={onhandleSubmit}
            >
              {loading ? "Please wait..." : "Sign In"}

              {loading && (
                <Box
                  sx={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress color="primary" size={20} />
                </Box>
              )}
            </button>
          </div>
          <p className="mt-8 text-center text-sm">
            Question? Email us at{" "}
            <a
              href="mailto:admin@pixell.in"
              className="font-medium hover:text-blue-500"
            >
              admin@pixell.in
            </a>
          </p>
        </div>
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{
            backgroundColor:
              snackbar.severity === "success"
                ? "var(--third-color)"
                : "var(--heading-color)",
            color: "var(--secondary-color)",
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default VendorPortal;
